import { FC } from 'react';

import Dropdown from '@components/Dropdown';
import { DropdownSelectProps } from '@components/Dropdown/DropdownInterface';

interface IGenderOption {
  key: string;
  label: string;
}

export const GENDER_OPTIONS: IGenderOption[] = [
  { key: 'F', label: 'Kadın' },
  { key: 'M', label: 'Erkek' },
];

export type IDropdownsGender = DropdownSelectProps<IGenderOption>;

const Gender: FC<IDropdownsGender> = ({ onChange = () => null, ...rest }) => {
  return (
    <Dropdown
      items={GENDER_OPTIONS}
      renderLabel={(p) => (!p ? 'Cinsiyet' : p.label)}
      renderOption={(p) => p.label}
      onChange={(gender) =>
        onChange((gender.key ?? '') as unknown as IGenderOption)
      }
      {...rest}
    />
  );
};

export default Gender;
